import { render, staticRenderFns } from "./ProposalSourceCell.vue?vue&type=template&id=66b9770e&scoped=true"
import script from "./ProposalSourceCell.vue?vue&type=script&lang=js"
export * from "./ProposalSourceCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b9770e",
  null
  
)

export default component.exports